import { useState } from "react";
import { useSelector } from "react-redux";
import { emotionBubbleStylesMapped } from "../../../models/interactions/EmotionBubble";
import EmotionDropdown from "../emotion_bubble/EmotionDropdown";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
import { selectSequenceVariables } from "../../../app/slices/TrainingSlice";
import RichTextEditor from "../../rich_text/RichTextEditor";
import { stripFormattingTags } from "../../rich_text/RichTextHtmlUtils";

export default function ConversationPreviewTextfield(props: {
  onSubmit: (text: string) => void;
  onEmotionSelect: (text: string) => void;
}) {
  const variables = useSelector(selectSequenceVariables);
  const [storedText, setStoredText] = useState<string>("");

  const submitMessage = (text: string): boolean => {
    if (!stripFormattingTags(text).trim()) {
      return false;
    }

    props.onSubmit(text);
    setStoredText("");
    return true;
  };

  const onChangeEmotion = (emotion: string) => {
    const newEmotion = emotionBubbleStylesMapped.find(
      (e) => e.name === emotion
    )!.name;

    props.onEmotionSelect(newEmotion);
  };

  const addReactionButton = (
    <div className="flex h-full items-center justify-center w-12 h-12 ml-[10px] border-0 cursor-pointer">
      <EmotionDropdown onChange={onChangeEmotion} />
    </div>
  );

  const sendButton = (
    <button
      aria-label="conversation-compose-send"
      disabled={!stripFormattingTags(storedText).trim()}
      className="flex items-center h-full justify-center w-12 ml-[10px] mr-3 border-0 cursor-pointer rounded-10 text-interaction-primary text-32 focus:outline-none disabled:text-interaction-disabled"
      onClick={() => submitMessage(storedText)}
    >
      <SendOutlinedIcon fontSize="inherit" color="inherit" />
    </button>
  );

  return (
    <div className="flex flex-col gap-[6px] w-full">
      <div className="flex items-end w-full min-h-[48px] max-h-[500px] justify-center">
        <RichTextEditor
          ariaLabel="conversation-compose-input"
          value={storedText}
          onCommit={setStoredText}
          onSubmitEnter={submitMessage}
          variables={variables}
          debounceMs={250}
          placeholder="Type a message"
          className="relative flex-1 min-h-[48px] max-h-[500px]"
          contentClassName="w-full min-h-[48px] max-h-[500px] overflow-y-auto pl-[8px] pt-[12px] font-poppins text-[16px] font-normal leading-[24px] text-interaction-primary caret-interaction-primary"
          warningClassName="text-[12px] font-medium text-creator-error"
          suggestionsMaxWidth={460}
        />
        {addReactionButton}
        {sendButton}
      </div>
    </div>
  );
}
